/** A retained source selector. Workflow scope, actor, time and endpoint belong to the server operation. */
export interface WorkflowFormLookupBinding {
  version: 1;
  configurationCode: string;
  domainCode: string;
  resolutionMode?: 'effective-context';
}

/** Retained server evidence, independent of the current effective catalogue. */
export interface WorkflowFormLookupAnswer {
  value: string; label: string; configurationCode: string; domainCode: string;
  configurationVersionId: number; revisionToken: string; resolvedAtUtc: string;
}

/** Recognize only the declarative lookup binding supported by the authoritative resolver. */
export function isWorkflowFormLookupBinding(value: unknown): value is WorkflowFormLookupBinding {
  if (!value || typeof value !== 'object' || Array.isArray(value)) return false;
  const binding = value as Record<string, unknown>;
  const code = (item: unknown) => typeof item === 'string' && item.length > 0 && item.length <= 120 && item === item.trim();
  return !Object.keys(binding).some(key => !['version', 'configurationCode', 'domainCode', 'resolutionMode'].includes(key))
    && binding['version'] === 1 && code(binding['configurationCode']) && code(binding['domainCode'])
    && (binding['resolutionMode'] === undefined || binding['resolutionMode'] === 'effective-context');
}

/** Compare the meaning of an omitted effective-context default without modifying either declaration. */
export function workflowFormLookupBindingKey(binding: WorkflowFormLookupBinding): string {
  return JSON.stringify([binding.version, binding.configurationCode, binding.domainCode, binding.resolutionMode ?? 'effective-context']);
}
